import React from 'react';
import { NavLink } from 'react-router-dom';


const Navbar =()=>{
    return (
        <>
        <nav className="navbar  navbar-expand-lg navbar-light bg-light fixed-top">
            <div className="container">
  <NavLink className="navbar-brand" to ="/">
      <img src="https://support-printers.netlify.app/img/logo.png" alt="" className='logo' />
  </NavLink>
  <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span className="navbar-toggler-icon"></span>
  </button>

  <a href="tel:+1-888-796-9007" className='my_btn'>Contact Us</a>
  </div>
</nav>
        </>
    )
}
export default Navbar;

